<div class="container-fluid pl-0 pr-0">
  <div class="modal-header">
    <div class="col-xs-11 col-md-11">
      <h4 class="modal-title fw-bold word-wrap">
        <span>{{ 'brapi-sync.germplasm-source-modal.title' | translate }}</span><span>{{sourceGermplasm.germplasmName}} (ID: {{sourceGermplasm.germplasmDbId}})</span>
      </h4>
    </div>
    <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true"
      (click)="clear()">
    </button>
  </div>
  <div class="modal-body">
    <app-collapsible [heading]="'brapi-sync.germplasm-source-modal.germplasm-attributes' | translate">
      <div class="card">
        <div class="card-body">
          @if (!sourceGermplasm.additionalInfo) {
            <span>{{ 'no.data' | translate }}</span>
          }
          @if (sourceGermplasm.additionalInfo) {
            <table class="table table-bordered table-striped table-curved">
              <thead class="thead-light">
                <tr>
                  <th>{{ 'brapi-sync.germplasm-source-modal.table.attribute-name' | translate }}</th>
                  <th>{{ 'brapi-sync.germplasm-source-modal.table.value' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (key of additionalInfo | objectKeys; track key) {
                  <tr>
                    <td>{{key}}</td>
                    <td>{{additionalInfo[key]}}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    </app-collapsible>
    <app-collapsible [heading]="'brapi-sync.germplasm-source-modal.external-references' | translate">
      <div class="card">
        <div class="card-body">
          @if (!sourceGermplasm.externalReferences) {
            <span>{{ 'no.data' | translate }}</span>
          }
          @if (sourceGermplasm.externalReferences) {
            <table class="table table-bordered table-striped table-curved">
              <thead class="thead-light">
                <tr>
                  <th>{{ 'brapi-sync.germplasm-source-modal.table.external-reference-id' | translate }}</th>
                  <th>{{ 'brapi-sync.germplasm-source-modal.table.external-reference-source' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (reference of sourceGermplasm.externalReferences; track reference) {
                  <tr>
                    <td>{{reference.referenceID}}</td>
                    <td>{{reference.referenceSource}}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    </app-collapsible>
    <app-collapsible [heading]="'brapi-sync.germplasm-source-modal.germplasm-origin' | translate">
      <div class="card">
        <div class="card-body">
          @if (!sourceGermplasm.germplasmOrigin) {
            <span>{{ 'no.data' | translate }}</span>
          }
          @if (sourceGermplasm.germplasmOrigin) {
            <ngx-json-viewer [json]="sourceGermplasm.germplasmOrigin"></ngx-json-viewer>
          }
        </div>
      </div>
    </app-collapsible>
  </div>
</div>
